/**
 * Frontend mirror of services/amMroConsecutiveApproval.js
 * AM MRO may not perform two consecutive workflow approvals/tasks on the same item.
 */

import { AM_MRO_CONSECUTIVE_WARNING, ROLES } from '../constants/roles';

export { AM_MRO_CONSECUTIVE_WARNING };

export const sameUserId = (a, b) => {
  if (!a || !b) return false;
  return String(a._id || a) === String(b._id || b);
};

export const isAmMroRole = (role) => role === ROLES.AM_MRO;

export const isAmMroConsecutiveBlocked = (user, previousActorId) => {
  if (!isAmMroRole(user?.role)) return false;
  return sameUserId(previousActorId, user?.id || user?._id);
};

export const getMaintenancePreviousActorForStep = (maintenance, step) => {
  if (!maintenance) return { actorId: null, label: null };

  switch (step) {
    case 'planning':
      return {
        actorId: maintenance.camoQmAcknowledgedBy,
        label: 'CAMO QM acknowledgment'
      };
    case 'store':
      return {
        actorId: maintenance.planningApprovedBy,
        label: 'Planning approval'
      };
    case 'mro_accept':
      if (maintenance.needsStoreAction && maintenance.storeAccepted) {
        return {
          actorId: maintenance.storeAcceptedBy,
          label: 'Store acceptance'
        };
      }
      return {
        actorId: maintenance.planningApprovedBy,
        label: 'Planning approval'
      };
    case 'mro_engineer_complete':
      return {
        actorId: maintenance.mroAcceptedBy,
        label: 'MRO acceptance'
      };
    case 'mro_qm_completion':
      return {
        actorId: maintenance.mroEngineerCompletedBy,
        label: 'MRO engineer completion'
      };
    default:
      return { actorId: null, label: null };
  }
};

export const getAmMroConsecutiveWarning = (user, previousActorId, previousStepLabel) => {
  if (!isAmMroConsecutiveBlocked(user, previousActorId)) return null;
  const label = previousStepLabel ? ` (previous: ${previousStepLabel})` : '';
  return `${AM_MRO_CONSECUTIVE_WARNING}${label}`;
};

export const getAmMroMaintenanceStepWarning = (user, maintenance, step) => {
  const { actorId, label } = getMaintenancePreviousActorForStep(maintenance, step);
  return getAmMroConsecutiveWarning(user, actorId, label);
};
